export const serverPhoneFormat = (phone) => {
    if (!phone || phone.includes('planneragent_')) {
        return phone
    }

    return 'planneragent_' + phone.split('-').join('')
}

const removePrefix = (str, prefix) => {
    if (str?.startsWith(prefix)) {
        return str.substring(prefix.length)
    }
    return str
}

export const removeUserPrefixes =
    (accountKey = 'ignore') =>
    (value) => {
        const prefixesToRemove = [
            `plannerclient${accountKey}_`,
            `${accountKey}_`,
            'plannerAgent_',
            'planneragent_',
        ]
        let cleanValue = value
        for (let prefixToRemove of prefixesToRemove) {
            cleanValue = removePrefix(cleanValue, prefixToRemove)
        }
        return cleanValue
    }

export const addServerPrefix = (str, prefix = 'plannerAgent_') =>
    str && !str.startsWith(prefix) && prefix + str
